export const SAVE = 'BaggageAndPersonalItemsTravellerTugo.SAVE';
export const VALUE_CHANGED = 'BaggageAndPersonalItemsTravellerTugo.VALUE_CHANGED';
export const LOAD = 'BaggageAndPersonalItemsTravellerTugo.VALUE_LOAD';
export const NEXT = 'BaggageAndPersonalItemsTravellerTugo.NEXT';
export const RESET = 'BaggageAndPersonalItemsTravellerTugo.RESET';
export const RESET_FORM_STATE = 'BaggageAndPersonalItemsTravellerTugo.RESET_FORM_STATE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.BaggageAndPersonalItemsTraveller/constants.js